import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPostLikes, sendLikeForPost } from '../../helpers/registrationHelper';
import Loading from '../Loading';

class Like extends Component {

    constructor(props) {
        super(props);
        this.props = props
        this.handleLike = this.handleLike.bind(this)
        this.state = {
            liked: false
        }
    }

    componentDidMount() {
        getPostLikes(this.props.post_id)
            .then((response) => {
                if (!response.data.error) {                    
                    var result = response.data.filter(function( like ) {
                        return like.user_id == localStorage.getItem('user_id');
                      });
                    this.setState({ likes: response.data,
                        liked: result.length !== 0 })
                    } else {
                        console.log('posted message incorrectly')
                }
            })
    }
    render() {
        if (!this.state) {
            return <Loading />
        } else {
            return ( 
                <div className="like-wrapper">
                    <div className="like-button">
                        <button onClick={this.handleLike}>
                            {this.state.liked ? <img className="like-image" alt="Like" src={require("../../images/like_plein.svg")} /> :
                                 <img className="like-image" alt="Like" src={require("../../images/like_stroke.svg")} />}                            </button>
                    </div>
                    <span className="likes-count">
                        {this.state.likes && this.state.likes.length}
                    </span>

                </div>
            )
        }
    }
    
    handleLike() {
        sendLikeForPost(this.props.post_id)
        .then((response) => {
            if (!response.data.error) {
                console.log('get message correctly')
                console.log(response.data)
                if(response.data && response.data.success) {
                    this.setState({ liked: false })
                } else {
                    this.setState({ liked: true })
                }
            } else {
                console.log('posted message incorrectly')
            }
        })
    }

}

Like.propTypes = {
    history: PropTypes.object,
    post_id: PropTypes.number
};

export default Like;



// WEBPACK FOOTER //
// ./src/components/newsline/like.js